import React from "react";

const SharesConsolidation = () => {
  return <div>SharesConsolidation</div>;
};

export default SharesConsolidation;
